"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

const MiscellaneousPageContainer = dynamic(async () =>
  withValidation(
    miscellanousPageContainerInputs,
    (await import("./MiscellaneousPageContainer")).MiscellaneousPageContainer,
    "MiscellaneousPageContainer"
  )
);

export const miscellanousPageContainerInputs = [
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "Page title",
  },
  {
    name: "sidebarBlocks",
    type: "uiBlocks",
    hideFromUI: true,
    defaultValue: [
      {
        "@type": "@builder.io/sdk:Element",
        component: {
          name: "QuickLinks",
        },
      },
    ],
  },
  {
    name: "contentBlocks",
    type: "uiBlocks",
    hideFromUI: false,
    defaultValue: [
      {
        "@type": "@builder.io/sdk:Element",
        component: {
          name: "Text",
          options: {
            text: "<p>Initial content</p>",
          },
        },
      },
    ],
  },
] as const satisfies Inputs;

export const MiscellaneousPageContainerComponent: RegisteredComponent = {
  name: "MiscellaneousPageContainer",
  component: MiscellaneousPageContainer,
  shouldReceiveBuilderProps: {
    builderBlock: true,
  },
  inputs: miscellanousPageContainerInputs,
};
